export default "__VITE_ASSET__BP7POQ_X__"